<template>
   <v-container>
     <v-row>
      <v-col cols="12">
        <v-img
          :src="require('@/assets/banner-finantare_alt.png')"
          class="mx-auto"
          contain
          max-height="150px"
        ></v-img>
      </v-col>
    </v-row>
    <v-row justify="center">
      <v-col sm="12" md="6">
        <v-card>
          <v-card-title>
            Contact
          </v-card-title>
          <v-card-text>
            <v-text-field
              prepend-icon="mdi-account-circle"
              shaped
              rounded
              solo
              dense
              flat
              outlined
              single-line
              v-model="nume"
              label="Nume"
              required
              hint="Numele dumneavoastra"
              persistent-hint
            ></v-text-field>
            <v-text-field
              prepend-icon="mdi-account-circle"
              shaped
              rounded
              solo
              dense
              flat
              outlined
              single-line
              v-model="prenume"
              label="Prenume"
              required
              hint="Prenumele dumneavoastra"
              persistent-hint
            ></v-text-field>
            <v-text-field
              prepend-icon="mdi-email"
              shaped
              rounded
              solo
              dense
              flat
              outlined
              single-line
              v-model="email"
              label="Email"
              required
              hint="Adresa dumneavoastra de email"
              persistent-hint
            ></v-text-field>
            <v-textarea
              prepend-icon="mdi-card-text"
              shaped
              rounded
              solo
              dense
              flat
              outlined
              single-line
              v-model="mesaj"
              label="Mesaj"
              required
              hint="Mesajul dumneavoastra"
              persistent-hint
            ></v-textarea>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" :disabled="!nume || !prenume || !email || !mesaj">
              <a class="text-button text-decoration-none white--text" target="_blank" :href="`mailto:office@asociatiaeuropas.ro?cc=${email}&body=${body}`">
                Trimiteti mesajul
              </a>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
   </v-container>
</template>

<script>
export default {
  name: "pla-contact",

  data: () => ({
    nume: null,
    prenume: null,
    email: null,
    mesaj: null
  }),

  computed: {
    body() {
      return encodeURIComponent(`
        Nume: ${this.nume}
        Preume: ${this.prenume}
        Email: ${this.email}
        Mesaj: ${this.mesaj}
      `);
    }
  }
}
</script>
